module.exports = __webpack_public_path__ + "static/img/active_vip_04.d7c466b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_vip_04.jpg
// module id = 7aUt
// module chunks = 0